import type { HTMLAttributes, ImgHTMLAttributes } from 'react';
import React from 'react';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import { MDXProvider } from '@mdx-js/react';
import { useFelaEnhanced } from '@ackee/fela';

import { LocalizedLink, type LocalizedLinkProps } from '../../../ui';
import { Quotation, type QuotationProps } from '../Quotation';
import { Callout, type CalloutProps } from '../Callout';

import * as felaRules from './MarkdownContent.rules';

export interface ContentProps {
    body: string;
}

export const MarkdownContent = ({ body }: ContentProps) => {
    const { styles, rules } = useFelaEnhanced(felaRules);

    return (
        <div className={styles.container}>
            <MDXProvider
                components={{
                    LocalizedLink: (props: LocalizedLinkProps) => (
                        <LocalizedLink {...props} extend={{ link: rules.link }} />
                    ),
                    img: (props: ImgHTMLAttributes<HTMLImageElement>) => <img {...props} className={styles.image} />,
                    figcaption: (props: HTMLAttributes<HTMLElement>) => (
                        <figcaption {...props} className={styles.imageCaption} />
                    ),
                    blockquote: (props: HTMLAttributes<HTMLElement>) => <Quotation>{props.children}</Quotation>,
                    Quotation: ({ author, children }: QuotationProps) => (
                        <Quotation author={author}>{children}</Quotation>
                    ),
                    button: (props: HTMLAttributes<HTMLButtonElement>) => (
                        <button {...props} className={styles.button} />
                    ),
                    video: (props: HTMLAttributes<HTMLVideoElement>) => <video {...props} className={styles.video} />,
                    Callout: (props: CalloutProps) => <Callout {...props} />,
                }}
            >
                <div className={styles.htmlContainer}>
                    <MDXRenderer>{body}</MDXRenderer>
                </div>
            </MDXProvider>
        </div>
    );
};
